/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';
import NoSSR from 'react-no-ssr';
import moment from 'moment-timezone';
import { formatSponsorNames } from '../../../pages/Events/SingleEvent/SingleEvent';
import FGBLabel from '../../Elements/FGBLabel/FGBLabel';
import MemberCountDisplay from '../../Groups/MemberCountDisplay/MemberCountDisplay';
import { eventStatusTypes } from '../../Includes/Constants/events';
import { eventPropTypesShape } from '../../Includes/eventsProps';
import { buildImagePath } from '../../JobComponents/Company/Image/logo';
import { getMonthByNumber } from '../../Utilities/TimeFunctions';
import EventRegisterButtonContainer from '../EventRegisterButton/EventRegisterButtonContainer';
import { countDown } from '../helperFunctions';
import SponsorDisplay from '../SponsorDisplay/SponsorDisplay';

import './SingleEventPageBanner.scss';

const SingleEventPageBanner = (props) => {
    const renderAttendeeSection = () => {
        const { attendeeCount, attendeeImages } = props;
        return attendeeCount && attendeeCount > 100 ? (
            <MemberCountDisplay
                count={attendeeCount}
                previewMembers={attendeeImages}
                overrideText="attending"
            />
        ) : null;
    };

    const {
        event,
        eventStatus,
        isUserRegistered,
        setUserAsRegistered,
        attendeeCount,
    } = props;

    const injectedTransforms = {
        banner: 'c_scale,w_1500,h_300',
        thumbnail: 'c_scale,f_auto,q_auto,w_440,h_330',
    };

    const banner = {
        src:
            event.bannerImage && event.bannerImage.src
                ? event.bannerImage.src
                : '/v1560887184/Event_bkgd_default_dwfvgs.png',
        alt:
            event.bannerImage && event.bannerImage.alt
                ? event.bannerImage.alt
                : 'default-banner-image',
    };

    let eventStatusDisplay = null;
    const countDownTimer = countDown(event.startTime);
    if (
        countDownTimer &&
        (eventStatus === eventStatusTypes.NOT_STARTED ||
            eventStatus === eventStatusTypes.STARTING_SOON) &&
        !!event.showCountdownTimer
    ) {
        eventStatusDisplay = (
            <div className="timer-display">
                Event Starts in <span>{countDownTimer}</span>
            </div>
        );
    }

    const hasSponsors = event.sponsors.length > 0;
    const sponsorLabelText = hasSponsors ? (
        <FGBLabel className="sponsor-name-display black-font">
            Sponsored by {formatSponsorNames(event.sponsors)}
        </FGBLabel>
    ) : null;

    const startDateUTC = new Date(moment.tz(event.startTime, 'UTC'));
    const momentStartTime = moment(startDateUTC).tz('America/New_York');
    const momentEndTime = moment(new Date(moment.tz(event.endTime, 'UTC'))).tz(
        'America/New_York'
    );
    const startTimeFormatted = momentStartTime.format('h:mm A');
    const endTimeFormatted = momentEndTime.format('h:mm A');
    const month = getMonthByNumber(momentStartTime.format('M'));
    const day = momentStartTime.format('D');
    const dayOfWeek = momentStartTime.format('dddd');

    return (
        <div className="component-Events-SingleEventPageBanner">
            <img
                className="banner-image"
                alt={banner.alt || ''}
                src={buildImagePath(banner.src, 'banner', injectedTransforms)}
            />
            <div className="content-display-card">
                <div className="content-display">
                    <img
                        className="thumbnail-image"
                        alt={event.image.alt || ''}
                        src={buildImagePath(
                            event.image.src,
                            'thumbnail',
                            injectedTransforms
                        )}
                    />
                    <div className="middle-content">
                        <div className="general-info-section">
                            <FGBLabel className="event-type-label single-event-event-type-label">
                                {event.eventType}
                            </FGBLabel>
                            <div className="title-section">{event.title}</div>
                        </div>
                        <div className="sponsor-info-display">
                            <div className="set-height">
                                <div className="sponsor-decorative-line">
                                    <SponsorDisplay sponsors={event.sponsors} />
                                </div>
                            </div>
                            <div className="info-display">
                                {sponsorLabelText}
                                {eventStatusDisplay}
                            </div>
                        </div>
                    </div>
                    <div className="date-time-info-display">
                        <FGBLabel className="day-of-week-label black-font">
                            {dayOfWeek}
                        </FGBLabel>
                        <div className="date-text-display">{`${month} ${day}`}</div>
                        <NoSSR>
                            <FGBLabel className="time-text-display black-font">{`${startTimeFormatted} - ${endTimeFormatted} ET`}</FGBLabel>
                        </NoSSR>
                        <EventRegisterButtonContainer
                            event={event}
                            isUserRegistered={isUserRegistered}
                            setUserAsRegistered={setUserAsRegistered}
                            isSingleEventPage
                        />
                        {attendeeCount ? renderAttendeeSection() : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

SingleEventPageBanner.propTypes = {
    /**
     * single event data
     */
    event: eventPropTypesShape.isRequired,
    attendeeCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    attendeeImages: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string.isRequired,
            alt: PropTypes.string,
        })
    ).isRequired,
    eventStatus: PropTypes.oneOf([
        eventStatusTypes.NOT_STARTED,
        eventStatusTypes.IN_PROGRESS,
        eventStatusTypes.EVENT_OVER,
        eventStatusTypes.STARTING_SOON,
    ]).isRequired,
    isUserRegistered: PropTypes.bool.isRequired,
    setUserAsRegistered: PropTypes.func.isRequired,
};

SingleEventPageBanner.defaultProps = {
    attendeeCount: null,
};

export default SingleEventPageBanner;
